import { BaseModel } from 'projects/core/src/lib/models/base.model';

export class RatingtypeModel extends BaseModel {

  // columns
  id: number;
  name: string;
  legend: string;
  description: string;
  min_value: number; // tslint:disable-line: variable-name
  max_value: number; // tslint:disable-line: variable-name
  step: number;

}
